import { useTranslation } from 'react-i18next';

import { GetCurrentPartnerResponse } from 'services/repositories/partners/partners';
import { isMessageV2DTO } from 'support/helpers/transactions/transactions';
import { MessageV2DTO, SenderEnvelopeDTO } from 'support/types';

import { SidebarSection } from '../../../../Sidebar/SidebarSection/SidebarSection';
import { RelatedMessage } from './RelatedMessage/RelatedMessage';

type RelatedMessagesProps = {
  activeMessageId: string | undefined;
  currentPartner?: GetCurrentPartnerResponse;
  relatedMessages?: Array<MessageV2DTO | SenderEnvelopeDTO>;
};

export function RelatedMessages({ activeMessageId, relatedMessages, currentPartner }: RelatedMessagesProps) {
  const { t } = useTranslation();

  if (!relatedMessages || !currentPartner) {
    return null;
  }

  if (relatedMessages.length === 0) {
    return (
      <SidebarSection header={{ title: t('transactions:show.sidebar.relatedMessages.label') }}>
        <div className="bg-gray-50 p-2 text-center text-xs text-gray-500">
          {t('transactions:show.sidebar.relatedMessages.noRelatedMessages')}
        </div>
      </SidebarSection>
    );
  }
  return (
    <SidebarSection header={{ title: t('transactions:show.sidebar.relatedMessages.label') }}>
      <div className="flow-root">
        <ul className="space-y-1">
          {relatedMessages.map((relatedMessage) => (
            <RelatedMessage
              key={relatedMessage.id}
              relatedMessage={{
                id: relatedMessage.id,
                type: 'type' in relatedMessage ? relatedMessage.type : relatedMessage.documentType,
                externalMessageRef: isMessageV2DTO(relatedMessage)
                  ? relatedMessage.external_message_ref
                  : relatedMessage.externalMessageRef,
                createdAt: isMessageV2DTO(relatedMessage) ? relatedMessage.created_at : relatedMessage.createdAt,
                state: isMessageV2DTO(relatedMessage) ? relatedMessage.state : relatedMessage.state,
              }}
              active={activeMessageId === relatedMessage.id}
            />
          ))}
        </ul>
      </div>
    </SidebarSection>
  );
}
